module.exports = __webpack_public_path__ + "img/pic-trafficInfo.a92c368b.jpg";